import api from './api';

const service = {

  /**
   * 取引状況照会
   */
  async searchStatus(params) {
    return await api.get(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/intraday/trading/select/merchandise`, { params: {
      pplant_id: params.pplant_id,
      time_code_type: params.time_code_type
    }});
  },
  async searchBoard(params) {
    return await api.get(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/timeCodeType/${params.time_code_type}/intraday/trading/board`);
  },

  /**
   * 札一覧管理
   */
  async searchBill(params) {
    return await api.get(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/bid_unit/${params.bid_unit}/intraday/trading/select/bill`, { params: {
      pplant_id: params.pplant_id,
      time_code_type: params.time_code_type,
      bid_status_type: params.bid_status,
      bid_kind: params.bid_kind
    }});
  },
  /**
   * 約定情報取得
   */
  async searchContract(condition, params) {
      return await api.get(`/aggregators/${condition.aggregator_id}/bid_unit/${condition.bid_unit_id}/areas/${condition.area_id}/target_date/${condition.target_date}/bid_unit/${condition.bid_unit}/time_code/${condition.time_code_type}/bid_kind/${condition.bid_kind}/control_number/${condition.control_number}/intraday/trading/select/contract`, { params });
  },

  /**
   * CSVアップロード
   */
  async uploadBid(params, file) {
    const form = new FormData();
    form.append('file', file);
    return await api.put(`/files/csv/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/bid_unit/${params.bid_unit}/intraday/trading/bid`, form , {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  /**
   * テンプレート取得
   */
  async downloadBid(params, reference) {
    const reference_list = [];
    if (reference.reference_flg) reference_list.push(1);
    if (reference.high_reference_flg) reference_list.push(2);
    if (reference.middle_reference_flg) reference_list.push(3);
    if (reference.low_reference_flg) reference_list.push(4);

    return await api.get(`/files/csv/aggregators/${params.aggregator_id}/bid_unit/${params.bid_unit}/areas/${params.area_id}/dates/${params.target_date}/intraday/trading/bid?reference_list=${reference_list}`, { responseType:'blob', dataType:'binary' });
  },
  
  /**
   * 入札申請
   */
  async apply(params, apply, isBulk, entry) {
    const payload = {...entry, bill_list: apply};
    return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/bid_unit/${params.bid_unit}/intraday/trading/create`, payload, { params: {
      isBulk: isBulk
    }});
  },
  
  /**
   * 申請取り止め
   */
  async cancelApply(params, apply, isBulk) {
    const payload = {bill_list: apply};
    return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/bid_unit/${params.bid_unit}/intraday/trading/cancel`, payload, { params: {
      isBulk: isBulk
    }});
  },
  
  /**
   * 入札承認
   */
  async approval(params, apply, isBulk) {
    const payload = {bill_list: apply};
    return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/bid_unit/${params.bid_unit}/intraday/trading/approval`, payload, { params: {
      isBulk: isBulk
    }});
  },
  
  /**
   * 差し戻し
   */
  async reject(params, apply, isBulk) {
    const payload = {bill_list: apply};
    return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/bid_unit/${params.bid_unit}/intraday/trading/reject`, payload, { params: {
      isBulk: isBulk
    }});
  },
  
  /**
   * 入札取消
   */
  async cancelBid(params, apply, isBulk) {
    const payload = {bill_list: apply};
    return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/bid_unit/${params.bid_unit}/intraday/trading/edit`, payload, { params: {
      isBulk: isBulk
    }});
  },
  
  /**
   * 削除
   */
  async remove(params, apply, isBulk) {
    const payload = {bill_list: apply};
    return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/bid_unit/${params.bid_unit}/intraday/trading/delete`, payload, { params: {
      isBulk: isBulk
    }});
  },
  
  /**
   * 入札量チェック
   */
  async check(params, apply, isBulk) {
    const payload = {bill_list: apply};
    return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/bid_unit/${params.bid_unit}/intraday/trading/bid_check`, payload, { params: {
      isBulk: isBulk
    }});
  },
}

export default service;